const shadows = {
  BOX_SHADOW: '0 2px 6px 0 rgba(0, 0, 0, .16)',
  BOX_SHADOW_SMALL: '0px 5px 10px 0px rgba(17, 17, 17, 0.08)',
  BOX_SHADOW_MINI: '0px 6.5px 13px 0px rgba(17, 17, 17, 0.04)',
  BOX_SHADOW_INVERTED: '0px -6px 10px 0 rgba(0, 0, 0, .08)',
}

export default shadows;
